import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export const MarketingTagType = {
  TEMPORAL: "temporal",
  CONTENT: "content",
  PROBLEM: "problem",
  SOLUTION: "solution",
  META: "meta",
} as const;

export type MarketingTagTypeValue = (typeof MarketingTagType)[keyof typeof MarketingTagType];

export const MarketingTagGroup = {
  PROBLEM: "problem",
  SYMPTOM: "symptom",
  CAUSE: "cause",
  WORK: "work",
  METHOD: "method",
  ELEMENT: "element",
  MATERIAL: "material",
  EVIDENCE_ROLE: "evidence_role",
  TEMPORAL: "temporal",
  CONTENT: "content",
  SHOT_TYPE: "shot_type",
  SAFETY_VISIBILITY: "safety_visibility",
  ACCESS_CONDITION: "access_condition",
  PROPERTY_CONTEXT: "property_context",
  SERVICE_LINE: "service_line",
  CONTENT_INTENT: "content_intent",
} as const;

export type MarketingTagGroupValue = (typeof MarketingTagGroup)[keyof typeof MarketingTagGroup];

export class MarketingTag extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare label: string;
  declare type: MarketingTagTypeValue;
  declare description: string | null;
  declare isFolderEligible: boolean;
  declare tagGroup: MarketingTagGroupValue | null;

  static get $name() {
    return "MarketingTag";
  }

  static get fields() {
    return [
      "id",
      "board",
      "label",
      "type",
      "description",
      { name: "isFolderEligible", dataSource: "is_folder_eligible", type: "boolean", defaultValue: false },
      { name: "tagGroup", dataSource: "tag_group" },
    ];
  }

  get isTemporal(): boolean {
    return this.type === MarketingTagType.TEMPORAL;
  }

  get isMeta(): boolean {
    return this.type === MarketingTagType.META;
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingTag.exposeProperties();
